export default __webpack_public_path__ + "static/assets/med_spheric_solid_01_mask.2d8f9733.png";